import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/VideoCta/VideoCta.js
const VideoCta = createSectionForm({
  icon: "youtube-line",
  title: "Video CTA",
  fields: [
    { name: "title", label: "Headline" },
    { name: "subtitle", label: "Sub Headline" },
    { name: "video_url", label: "YouTube Video", type: "video", fullWidth: true },
  ],
});

export default VideoCta;
